module.exports = __webpack_public_path__ + "static/logo-52170685231e562c1bbb1985c4b80fe7.png";